import { useEffect, useState } from "react";
import { getComparisonScoringConfigById } from "../services/scoringService";

const useFetchComparisonScoringConfigById = ({
  setIsLoading,
  configId,
}: any) => {
  const [configData, setConfigData] = useState<any>({});
  useEffect(() => {
    if (configId && configId > 0) {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const result = await getComparisonScoringConfigById(configId);
          setConfigData(result);
        } catch (err) {
          setConfigData({});
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [configId]);

  return [configData];
};

export default useFetchComparisonScoringConfigById;

